// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 818 ? "fc1064d0" : chunkId) + "." + {"253":"82968d9971516f37","722":"5dbae72359952cdd","814":"1bd2515876df02a6","818":"16c6e072e858fd7d"}[chunkId] + ".js";
};